// This file was automatically generated from appchart.dialog.editReportDetails.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.editReportDetails');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.editReportDetails.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><form><div class="el8FieldSection"><label class="el8label el8FieldLong">Document Date:</label><div class="el8FieldLongLabelPadding el8TextareaWrap datePickerWrap"><input type="text" class="datePicker" name="documentDate" /></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong">Report Category:</label><div class="el8FieldLongLabelPadding el8Wrap"><select name="reportType"></select></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong">Report Title:</label><div class="el8FieldLongLabelPadding el8TextareaWrap"><input type="text" class="w100" name="customTitle" /></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong">Tags:</label><div class="doctags-holder el8FieldLongLabelPadding"></div></div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.editReportDetails.reportTypeOptions = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var objList1498 = opt_data.reportTypes;
  var objListLen1498 = objList1498.length;
  for (var objIndex1498 = 0; objIndex1498 < objListLen1498; objIndex1498++) {
    var objData1498 = objList1498[objIndex1498];
    output.append('<option value="', soy.$$escapeHtml(objData1498.value), '">', soy.$$escapeHtml(objData1498.description), ' Report</option>');
  }
  if (!opt_sb) return output.toString();
};
